export const TOKEN_TYPE = {
    SET_PASSWORD: "Set Password",
    FORGOT_PASSWORD: "Forgot Password",
    INITIAL_PASSWORD: "Initial Password"
};